import React, { Component } from 'react';
import counterpart from 'counterpart';

import withLoad from 'components/hocs/withLoad';

export default function withTranslateChange(onTranslateChange) {
    return WrappedComponent => class TranslateChange extends Component {
        componentDidMount() {
            counterpart.onLocaleChange(this.translateChanged);
        }

        componentWillUnmount() {
            counterpart.offLocaleChange(this.translateChanged);
        }

        translateChanged = (next, current) => {
            if (next !== current) {
                onTranslateChange(this.props);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

const reloadDict = props => props.dictionaryAction.refresh();

export const withTranslateLoad = WrappedComponent => withLoad(withTranslateChange(reloadDict)(WrappedComponent));
